module.exports = __webpack_public_path__ + "static/media/CardBack.04a9105f.svg";